import React from "react";
import moment, { Moment } from "moment";

interface OwnProps {
  dob: Moment;
}

type Props = OwnProps;

export default class DobAgeProvider extends React.PureComponent<Props> {
  private getAge() {
    return moment().diff(this.props.dob, "years");
  }

  private getDateFormatted() {
    return moment(this.props.dob).calendar();
  }

  public render() {
    return (
      <>
        {this.props.dob.isValid() && (
          <span>
            {this.getDateFormatted()} <span className="divider"></span> {this.getAge()}
          </span>
        )}
      </>
    );
  }
}
